// import { canUseDOM } from 'exenv';

export function companyIndexSectionNextLoading(resp = {}, store = {}) {
  return {
    type: 'COMPANY_INDEX_SECTION_NEXT_LOADING',
    companyIndexSectionNext: resp,
    store
  };
}

export function companyIndexSectionNextLoaded(resp = {}, store = {}) {
  return {
    type: 'COMPANY_INDEX_SECTION_NEXT_LOADED',
    companyIndexSectionNext: resp,
    store
  };
}

export function companyIndexSectionNextLoadError(error, store = {}) {
  return {
    type: 'COMPANY_INDEX_SECTION_NEXT_ERROR',
    companyIndexSectionNext: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store
  };
}
